{
  "app-switcher-discovery-section.discover-more-products": [
    {
      "type": 0,
      "value": "Discover more apps"
    }
  ],
  "app-switcher-discovery-section.more-atlassian-products": [
    {
      "type": 0,
      "value": "More Atlassian apps"
    }
  ],
  "app-switcher-discovery-section.recommended-for-your-team": [
    {
      "type": 0,
      "value": "Recommended for your team"
    }
  ],
  "confluence.continue.reading.body": [
    {
      "children": [
        {
          "type": 0,
          "value": "Related reading from "
        },
        {
          "type": 1,
          "value": "pageOwnerName"
        }
      ],
      "type": 8,
      "value": "text"
    }
  ],
  "confluence.continue.reading.read-now": [
    {
      "type": 0,
      "value": "Read now"
    }
  ],
  "continue-reading.ai-footer.content-quality": [
    {
      "children": [
        {
          "type": 0,
          "value": "Content quality may vary"
        }
      ],
      "type": 8,
      "value": "text"
    }
  ],
  "continue-reading.ai-footer.powered-by-ai": [
    {
      "children": [
        {
          "type": 0,
          "value": "Powered by AI"
        }
      ],
      "type": 8,
      "value": "text"
    }
  ],
  "cross-flow-itsm-template.jsm.title": [
    {
      "type": 0,
      "value": "Collect IT requests"
    }
  ],
  "cross-flow-product-prioritization-template.jpd.title": [
    {
      "type": 0,
      "value": "Prioritize ideas"
    }
  ],
  "cross-flow-product-request-pending.jpd.title": [
    {
      "type": 0,
      "value": "Product roadmap"
    }
  ],
  "cross-flow-product-request-pending.jsm.title": [
    {
      "type": 0,
      "value": "Work requests"
    }
  ],
  "cross-flow-product-roadmap-template.jpd.title": [
    {
      "type": 0,
      "value": "Create a roadmap"
    }
  ],
  "cross-flow-work-requests-template.jsm.title": [
    {
      "type": 0,
      "value": "Collect requests"
    }
  ],
  "first-party-recommendation.reason-1": [
    {
      "type": 0,
      "value": "the size of your team"
    }
  ],
  "first-party-recommendation.reason-2": [
    {
      "type": 0,
      "value": "your existing Atlassian products"
    }
  ],
  "growth.app-switcher-discovery-section.flag.description": [
    {
      "type": 0,
      "value": "You won’t see this here as often."
    }
  ],
  "growth.app-switcher-discovery-section.flag.title": [
    {
      "type": 0,
      "value": "Got it, thanks for letting us know"
    }
  ],
  "growth.app-switcher-discovery-section.wac-toast.close.aria-label": [
    {
      "type": 0,
      "value": "Dismiss toast"
    }
  ],
  "growth.confluence-nudge-for-jira.action": [
    {
      "type": 0,
      "value": "Accept invitation"
    }
  ],
  "growth.confluence-nudge-for-jira.description": [
    {
      "type": 0,
      "value": "Accept your invitation to make sure you're not missing any project updates."
    }
  ],
  "growth.confluence-nudge-for-jira.title": [
    {
      "type": 0,
      "value": "Your team invited you to Jira"
    }
  ],
  "growth.confluenceNudgeFlag.flagHeadline.commentedOnPage.text": [
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        },
        {
          "type": 0,
          "value": " commented on your page"
        }
      ],
      "type": 8,
      "value": "h"
    }
  ],
  "growth.confluenceNudgeFlag.flagHeadline.mentionedInComment.text": [
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        },
        {
          "type": 0,
          "value": " mentioned you in a comment"
        }
      ],
      "type": 8,
      "value": "h"
    }
  ],
  "growth.confluenceNudgeFlag.flagHeadline.mentionedInPage.text": [
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        },
        {
          "type": 0,
          "value": " mentioned you on a page"
        }
      ],
      "type": 8,
      "value": "h"
    }
  ],
  "growth.confluenceNudgeFlag.repliedSuccessFlagTitle.text": [
    {
      "type": 0,
      "value": "Reply sent to "
    },
    {
      "type": 1,
      "value": "mentionerName"
    }
  ],
  "growth.confluenceNudgeFlag.reply-cancel-button": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "growth.confluenceNudgeFlag.reply-confirm-button": [
    {
      "type": 0,
      "value": "Reply"
    }
  ],
  "growth.confluenceNudgeFlag.reply-on-page-confirm-button.text": [
    {
      "children": [
        {
          "type": 0,
          "value": "Reply on page"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "growth.confluenceNudgeFlag.replyFieldGenericError": [
    {
      "type": 0,
      "value": "Failed to send comment. Please try again later."
    }
  ],
  "growth.confluenceNudgeFlag.see-page-confirm-button": [
    {
      "children": [
        {
          "type": 0,
          "value": "See page"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "growth.confluenceNudgeFlag.see-page-confirm-button.success.flag": [
    {
      "children": [
        {
          "type": 0,
          "value": "See page"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "growth.confluenceNudgeFlag.viewReactionsError": [
    {
      "type": 0,
      "value": "Reactions failed to load"
    }
  ],
  "growth.placement-v2.atlas-side-nav-app-recommendation-menu-item.try-new-product": [
    {
      "type": 0,
      "value": "TRY"
    }
  ],
  "growth.recommendation-atlas.value-proposition": [
    {
      "type": 0,
      "value": "Your company's teamwork directory"
    }
  ],
  "growth.recommendation-confluence.cta.label": [
    {
      "type": 0,
      "value": "Try Confluence"
    }
  ],
  "growth.recommendation-confluence.jira-your-work.description": [
    {
      "type": 0,
      "value": "Create a centralized space to organize requirements, release notes, goals, and more."
    }
  ],
  "growth.recommendation-confluence.jira-your-work.header": [
    {
      "type": 0,
      "value": "Get everyone on the same page"
    }
  ],
  "growth.recommendation-confluence.jira-your-work.header-image-alt-text": [
    {
      "type": 0,
      "value": "Multiple people collaborating and commenting on the same page at the same time"
    }
  ],
  "growth.recommendation-confluence.jira-your-work.reasons-modal.message": [
    {
      "type": 0,
      "value": "We think "
    },
    {
      "type": 1,
      "value": "confluence"
    },
    {
      "type": 0,
      "value": " will improve your team's productivity. The recommendation is based on:"
    }
  ],
  "growth.recommendation-confluence.product-alt-text": [
    {
      "type": 0,
      "value": "A document titled quarterly planning. The document has details like mission, scope and a monthly plan."
    }
  ],
  "growth.recommendation-confluence.product-heading": [
    {
      "type": 0,
      "value": "Create one source of truth, for all"
    }
  ],
  "growth.recommendation-confluence.product-name.header": [
    {
      "type": 0,
      "value": "Collaborate on pages in real-time"
    }
  ],
  "growth.recommendation-confluence.product-subheading": [
    {
      "type": 0,
      "value": "Create and link documents like release notes, product requirements, and roadmaps from a single place."
    }
  ],
  "growth.recommendation-confluence.reasons-modal.message": [
    {
      "type": 0,
      "value": "We think "
    },
    {
      "type": 1,
      "value": "confluence"
    },
    {
      "type": 0,
      "value": " will improve your team's productivity. The recommendation is based on:"
    }
  ],
  "growth.recommendation-confluence.value-proposition": [
    {
      "type": 0,
      "value": "Document collaboration"
    }
  ],
  "growth.recommendation-jira.product-alt-text": [
    {
      "type": 0,
      "value": "A board view to move tasks from to do, to in progress to done"
    }
  ],
  "growth.recommendation-jira.product-heading": [
    {
      "type": 0,
      "value": "Plan and track work across teams"
    }
  ],
  "growth.recommendation-jira.product-subheading": [
    {
      "type": 0,
      "value": "Break big ideas down into achievable steps. Organize work, create milestones, map dependencies, and get visibility across all teams."
    }
  ],
  "growth.recommendation-jpd-product-roadmap.value-proposition": [
    {
      "type": 0,
      "value": "Align everyone with custom roadmaps"
    }
  ],
  "growth.recommendation-jpd.admin-hub-recommendation-value-proposition": [
    {
      "type": 0,
      "value": "Plan and deliver all on the same platform"
    }
  ],
  "growth.recommendation-jpd.cta.label": [
    {
      "type": 0,
      "value": "Try Jira Product Discovery"
    }
  ],
  "growth.recommendation-jpd.jira-your-work.description": [
    {
      "type": 0,
      "value": "Prioritize your ideas then easily move them into delivery, without losing any details on the way."
    }
  ],
  "growth.recommendation-jpd.jira-your-work.header": [
    {
      "type": 0,
      "value": "Build right features, the right way"
    }
  ],
  "growth.recommendation-jpd.jira-your-work.header-image-alt-text": [
    {
      "type": 0,
      "value": "An idea in Jira Product Discovery automatically turning into an Epic in Jira"
    }
  ],
  "growth.recommendation-jpd.jira-your-work.reasons-modal.message": [
    {
      "type": 0,
      "value": "We think "
    },
    {
      "type": 1,
      "value": "jpd"
    },
    {
      "type": 0,
      "value": " will improve your team's productivity. The recommendation is based on:"
    }
  ],
  "growth.recommendation-jpd.product-alt-text": [
    {
      "type": 0,
      "value": "Five ideas are all organized into now, next and later groups, with a goal, score and effort ranking connected to each idea."
    }
  ],
  "growth.recommendation-jpd.product-heading": [
    {
      "type": 0,
      "value": "Build the right features, the right way"
    }
  ],
  "growth.recommendation-jpd.product-name.header": [
    {
      "type": 0,
      "value": "Transform insights into action plans"
    }
  ],
  "growth.recommendation-jpd.product-subheading": [
    {
      "type": 0,
      "value": "Capture and prioritize your ideas, then easily move them into delivery, without losing any details on the way."
    }
  ],
  "growth.recommendation-jpd.reasons-modal.message": [
    {
      "type": 0,
      "value": "We think "
    },
    {
      "type": 1,
      "value": "jpd"
    },
    {
      "type": 0,
      "value": " will improve your team's productivity. The recommendation is based on:"
    }
  ],
  "growth.recommendation-jpd.value-proposition": [
    {
      "type": 0,
      "value": "Prioritize, collaborate, and deliver new ideas"
    }
  ],
  "growth.recommendation-jsm-work-request.value-proposition": [
    {
      "type": 0,
      "value": "Create one place to manage requests"
    }
  ],
  "growth.recommendation-jsm.admin-hub-recommendation-value-prop": [
    {
      "type": 0,
      "value": "Bring your developers, IT, and operations onto the same platform."
    }
  ],
  "growth.recommendation-jsm.cta.label": [
    {
      "type": 0,
      "value": "Try Jira Service Management"
    }
  ],
  "growth.recommendation-jsm.jira-your-work.description": [
    {
      "type": 0,
      "value": "Connect support teams with development teams to get the full picture, from request to resolution."
    }
  ],
  "growth.recommendation-jsm.jira-your-work.header": [
    {
      "type": 0,
      "value": "Link your teams, make work visible"
    }
  ],
  "growth.recommendation-jsm.jira-your-work.header-image-alt-text": [
    {
      "type": 0,
      "value": "Requests from Slack, Teams and email turning into a Jira Service Management request automatically"
    }
  ],
  "growth.recommendation-jsm.jira-your-work.reasons-modal.message": [
    {
      "type": 0,
      "value": "We think "
    },
    {
      "type": 1,
      "value": "jsm"
    },
    {
      "type": 0,
      "value": " will improve your team's productivity. The recommendation is based on:"
    }
  ],
  "growth.recommendation-jsm.product-alt-text": [
    {
      "type": 0,
      "value": "Seven requests are all organized in one place, with a status and project connected to each request."
    }
  ],
  "growth.recommendation-jsm.product-heading": [
    {
      "type": 0,
      "value": "Make your work more visible"
    }
  ],
  "growth.recommendation-jsm.product-name.header": [
    {
      "type": 0,
      "value": "Automate workflows for faster resolutions"
    }
  ],
  "growth.recommendation-jsm.product-subheading": [
    {
      "type": 0,
      "value": "Connect Dev and Ops teams on a single platform to collaborate and connect the whole picture, from request to resolution."
    }
  ],
  "growth.recommendation-jsm.reasons-modal.message": [
    {
      "type": 0,
      "value": "We think "
    },
    {
      "type": 1,
      "value": "jsm"
    },
    {
      "type": 0,
      "value": " will improve your team's productivity. The recommendation is based on:"
    }
  ],
  "growth.recommendation-jsm.value-proposition": [
    {
      "type": 0,
      "value": "Collaborative IT service management"
    }
  ],
  "growth.recommendation-jsw-visualize-work.cta.label": [
    {
      "type": 0,
      "value": "Try Jira"
    }
  ],
  "growth.recommendation-jsw-visualize-work.product-name.header": [
    {
      "type": 0,
      "value": "Visualize your projects in lists, boards, and more"
    }
  ],
  "growth.recommendation-jsw-visualize-work.reasons-modal.message": [
    {
      "type": 0,
      "value": "We think "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " will improve your team's productivity. The recommendation is based on:"
    }
  ],
  "growth.recommendation-jsw.recommendations.dropdown-menu-trigger.aria-label": [
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " options"
    }
  ],
  "growth.recommendation-jsw.value-proposition": [
    {
      "type": 0,
      "value": "Project and issue tracking"
    }
  ],
  "growth.recommendation-jwm.value-proposition": [
    {
      "type": 0,
      "value": "ITSM that unlocks high-velocity teams"
    }
  ],
  "growth.recommendation-loom.cta.label": [
    {
      "type": 0,
      "value": "Try Loom"
    }
  ],
  "growth.recommendation-loom.product-name.header": [
    {
      "type": 0,
      "value": "Record and share videos easily"
    }
  ],
  "growth.recommendation-loom.reasons-modal.message": [
    {
      "type": 0,
      "value": "We think "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " will improve your team's productivity. The recommendation is based on:"
    }
  ],
  "growth.recommendation-loom.value-proposition": [
    {
      "type": 0,
      "value": "Record and share videos easily"
    }
  ],
  "growth.recommendation-opsgenie.value-proposition": [
    {
      "type": 0,
      "value": "Modern incident management"
    }
  ],
  "growth.recommendation-product-store.learn-cta-button-text": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "growth.recommendation-product-store.try-cta-button-text": [
    {
      "type": 0,
      "value": "Try it now"
    }
  ],
  "growth.recommendation-twc.confluence-apps-description": [
    {
      "type": 0,
      "value": "Jira, video, and AI"
    }
  ],
  "growth.recommendation-twc.confluence-apps-title": [
    {
      "type": 0,
      "value": "Apps that click with Confluence"
    }
  ],
  "growth.recommendation-twc.image-alt-text": [
    {
      "type": 0,
      "value": "Rovo and Loom"
    }
  ],
  "growth.recommendation-twc.jira-apps-description": [
    {
      "type": 0,
      "value": "Add video and AI to Jira to work smarter."
    }
  ],
  "growth.recommendation-twc.jira-apps-title": [
    {
      "type": 0,
      "value": "Transform teamwork"
    }
  ],
  "growth.recommendation-twc.twc-apps-brand-description": [
    {
      "type": 0,
      "value": "Try Loom video and Rovo AI"
    }
  ],
  "growth.recommendation-twc.twc-apps-brand-description-if-user-has-jira-only": [
    {
      "type": 0,
      "value": "Try Confluence, Loom, and Rovo"
    }
  ],
  "growth.recommendation-twc.twc-apps-brand-title": [
    {
      "type": 0,
      "value": "Teamwork Collection"
    }
  ],
  "growth.recommendation-twc.twc-apps-description": [
    {
      "type": 0,
      "value": "Docs, video, and agents in one place"
    }
  ],
  "growth.recommendation-twc.twc-apps-lozenge": [
    {
      "type": 0,
      "value": "New"
    }
  ],
  "growth.recommendation-twc.twc-apps-non-tech-description": [
    {
      "type": 0,
      "value": "Connect plans and docs using AI"
    }
  ],
  "growth.recommendation-twc.twc-apps-non-tech-title": [
    {
      "type": 0,
      "value": "A smarter way to work"
    }
  ],
  "growth.recommendation-twc.twc-apps-product-benefits-description": [
    {
      "type": 0,
      "value": "Run your whole project seamlessly"
    }
  ],
  "growth.recommendation-twc.twc-apps-product-benefits-title": [
    {
      "type": 0,
      "value": "1 collection, 4 tools"
    }
  ],
  "growth.recommendation-twc.twc-apps-tech-description": [
    {
      "type": 0,
      "value": "Work 3x faster with connected tools"
    }
  ],
  "growth.recommendation-twc.twc-apps-tech-title": [
    {
      "type": 0,
      "value": "Tools built for speed"
    }
  ],
  "growth.recommendation-twc.twc-apps-title": [
    {
      "type": 0,
      "value": "Work faster across tools"
    }
  ],
  "growth.recommendation-twc.twc-apps-value-benefits-description": [
    {
      "type": 0,
      "value": "Plan, track, and collaborate together"
    }
  ],
  "growth.recommendation-twc.twc-apps-value-benefits-title": [
    {
      "type": 0,
      "value": "Accelerate teamwork"
    }
  ],
  "growth.recommendation-twc.twc-image-alt-text": [
    {
      "type": 0,
      "value": "Teamwork Collection"
    }
  ],
  "growth.team-25-ipm.jira-your-work.call-to-action.watch-now.text": [
    {
      "type": 0,
      "value": "Watch now"
    }
  ],
  "growth.team-25-ipm.jira-your-work.description": [
    {
      "type": 0,
      "value": "See how Rovo can improve the way you work with AI search, chat, and agents."
    }
  ],
  "growth.team-25-ipm.jira-your-work.header-image-alt-text": [
    {
      "type": 0,
      "value": "See the Rovo announcement!"
    }
  ],
  "growth.team-25-ipm.jira-your-work.reasons-modal.message": [
    {
      "type": 0,
      "value": "Atlassian recently shared multiple announcements at Team '25, and we wanted to make sure you know about our new capabilities."
    }
  ],
  "growth.team-25-ipm.jira-your-work.title": [
    {
      "type": 0,
      "value": "Work better with Rovo"
    }
  ],
  "post-office.ad-controls.confluence-continue-reading-nudge.reason.activity-in-product": [
    {
      "type": 0,
      "value": "Your activity in Confluence"
    }
  ],
  "post-office.ad-controls.confluence-continue-reading-nudge.reason.suggested-next-steps": [
    {
      "type": 0,
      "value": "Suggested next steps to help you get more value out of Atlassian"
    }
  ],
  "post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.message": [
    {
      "type": 0,
      "value": "You're seeing a personalized recommendation based on:"
    }
  ],
  "post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.title": [
    {
      "type": 0,
      "value": "Why am I seeing this?"
    }
  ],
  "post-office.ad-controls.confluence-mcu-nudge-flag-message.recommendation-basis": [
    {
      "type": 0,
      "value": "You’re seeing a personalized recommendation based on:"
    }
  ],
  "post-office.ad-controls.confluence-mcu-nudge-flag-reason.activity-in-product": [
    {
      "type": 0,
      "value": "Your activity in Confluence"
    }
  ],
  "post-office.ad-controls.confluence-mcu-nudge-flag-title.why-am-i-seeing-this": [
    {
      "type": 0,
      "value": "Why am I seeing this?"
    }
  ],
  "post-office.ad-controls.confluence-mcu-nudge-flag.suggestions": [
    {
      "type": 0,
      "value": "Suggested next steps to help you get more value out of Atlassian"
    }
  ],
  "post-office.ad-controls.custom-dropdown-item.1.no-translate": [
    {
      "type": 0,
      "value": "the first custom dropdown item"
    }
  ],
  "post-office.ad-controls.custom-dropdown-item.2.no-translate": [
    {
      "type": 0,
      "value": "the second custom dropdown item"
    }
  ],
  "post-office.ad-controls.custom-reason.existing-products.no-translate": [
    {
      "type": 0,
      "value": "the second reason for displaying the message to the customer"
    }
  ],
  "post-office.ad-controls.custom-reason.team-size.no-translate": [
    {
      "type": 0,
      "value": "the first reason for displaying the message to the customer"
    }
  ],
  "post-office.ad-controls.default-reason.existing-products": [
    {
      "type": 0,
      "value": "your existing Atlassian products"
    }
  ],
  "post-office.ad-controls.default-reason.team-size": [
    {
      "type": 0,
      "value": "the size of your team"
    }
  ],
  "post-office.ad-controls.dismiss-flag.not-interested.subtitle": [
    {
      "type": 0,
      "value": "You won’t see this here as often."
    }
  ],
  "post-office.ad-controls.dismiss-flag.not-interested.title": [
    {
      "type": 0,
      "value": "Got it, thanks for letting us know"
    }
  ],
  "post-office.ad-controls.dropdown-item.not-interested.label": [
    {
      "type": 0,
      "value": "Not interested"
    }
  ],
  "post-office.ad-controls.dropdown-item.remind-me-later.label": [
    {
      "type": 0,
      "value": "Remind me later"
    }
  ],
  "post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label": [
    {
      "type": 0,
      "value": "Why am I seeing this?"
    }
  ],
  "post-office.ad-controls.dropdown-menu-trigger.aria-label": [
    {
      "type": 1,
      "value": "messageInstanceId"
    },
    {
      "type": 0,
      "value": " options menu"
    }
  ],
  "post-office.ad-controls.dropdown-menu-trigger.tooltip": [
    {
      "type": 0,
      "value": "More actions"
    }
  ],
  "post-office.ad-controls.next-best-action-message.recommendation-basis": [
    {
      "type": 0,
      "value": "This recommendation is based on:"
    }
  ],
  "post-office.ad-controls.next-best-action-reason.actions-done-so-far": [
    {
      "type": 0,
      "value": "What you’ve done so far in the product"
    }
  ],
  "post-office.ad-controls.next-best-action-reason.suggestions": [
    {
      "type": 0,
      "value": "What we suggest to help you get the most value from Atlassian"
    }
  ],
  "post-office.ad-controls.next-best-action-title.why-am-i-seeing-this": [
    {
      "type": 0,
      "value": "Why am I seeing this?"
    }
  ],
  "post-office.ad-controls.reasons-modal.accept-button.label-ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "post-office.ad-controls.reasons-modal.body": [
    {
      "type": 0,
      "value": "We think you'd find this relevant. This is based on:"
    }
  ],
  "post-office.ad-controls.reasons-modal.privacy-policy-link.text": [
    {
      "type": 0,
      "value": "Learn more about your data privacy with Atlassian"
    }
  ],
  "post-office.ad-controls.reasons-modal.title": [
    {
      "type": 0,
      "value": "Why am I seeing this?"
    }
  ],
  "post-office.close-button.tooltip": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "post-office.confluence-banner-first-party-recommendation.try-it-now": [
    {
      "type": 0,
      "value": "Try it now"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.craete-space-header": [
    {
      "type": 0,
      "value": "Centralize your team's projects, and docs."
    }
  ],
  "post-office.confluence-side-nav.next-best-action.create-page-cta-message": [
    {
      "type": 0,
      "value": "Create page"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.create-page-header": [
    {
      "type": 0,
      "value": "Plan projects, take notes, and track tasks."
    }
  ],
  "post-office.confluence-side-nav.next-best-action.create-space-cta-message": [
    {
      "type": 0,
      "value": "Create space"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message": [
    {
      "type": 0,
      "value": "Create whiteboard"
    }
  ],
  "post-office.confluence-side-nav.next-best-action.create-whiteboard-header": [
    {
      "type": 0,
      "value": "Dream up new ideas, and visualize your work."
    }
  ],
  "post-office.example-message-template.example-placement.cta-button.no-translate": [
    {
      "type": 0,
      "value": "Try now"
    }
  ],
  "post-office.example-placement-advanced.learn-more-modal.done-button-text.no-translate": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "post-office.example-placement-quick-start.main-heading.no-translate": [
    {
      "type": 0,
      "value": "Welcome to Placements v2"
    }
  ],
  "post-office.growth.jira-activation-project-recommendation.check-jira": [
    {
      "type": 0,
      "value": "Check Jira"
    }
  ],
  "post-office.growth.jira-activation-project-recommendation.hello-message": [
    {
      "type": 0,
      "value": ":wave: Hey "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "post-office.growth.jira-activation-project-recommendation.message-text": [
    {
      "type": 0,
      "value": "Have you checked Jira lately? You may be missing out on important updates. Take a quick look to see if your team is using it to track any of your projects."
    }
  ],
  "post-office.growth.jira-activation-project-recommendation.messages-exist": [
    {
      "type": 0,
      "value": "Don’t forget to get caught up on your "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "project"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "projects"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "numberOfProjects"
    },
    {
      "type": 0,
      "value": " in Jira! Take a quick look to get up-to-date on your teammates’ progress."
    }
  ],
  "post-office.growth.jira-activation-project-recommendation.see-projects": [
    {
      "type": 0,
      "value": "See all projects"
    }
  ],
  "post-office.growth.jira-activation-project-recommendation.you-have-messages": [
    {
      "offset": 0,
      "options": {
        "=0": {
          "value": [
          ]
        },
        "=1": {
          "value": [
          ]
        },
        "=2": {
          "value": [
            {
              "type": 0,
              "value": "You have *two projects*:"
            }
          ]
        },
        "=3": {
          "value": [
            {
              "type": 0,
              "value": "You have *three projects*:"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "You have *"
            },
            {
              "options": {
                "4": {
                  "value": [
                    {
                      "type": 0,
                      "value": "four"
                    }
                  ]
                },
                "5": {
                  "value": [
                    {
                      "type": 0,
                      "value": "five"
                    }
                  ]
                },
                "6": {
                  "value": [
                    {
                      "type": 0,
                      "value": "six"
                    }
                  ]
                },
                "7": {
                  "value": [
                    {
                      "type": 0,
                      "value": "seven"
                    }
                  ]
                },
                "8": {
                  "value": [
                    {
                      "type": 0,
                      "value": "eight"
                    }
                  ]
                },
                "9": {
                  "value": [
                    {
                      "type": 0,
                      "value": "nine"
                    }
                  ]
                },
                "other": {
                  "value": [
                    {
                      "type": 1,
                      "value": "numberOfProjects"
                    }
                  ]
                }
              },
              "type": 5,
              "value": "numberOfProjects"
            },
            {
              "type": 0,
              "value": " projects*. Here are three to get you started:"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "numberOfProjects"
    }
  ],
  "post-office.growth.jira-assigned-nudge-digest.hello-message-for-multiple-projects": [
    {
      "type": 0,
      "value": ":wave: Just a heads up — you have *"
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "one project"
            }
          ]
        },
        "other": {
          "value": [
            {
              "options": {
                "2": {
                  "value": [
                    {
                      "type": 0,
                      "value": "two"
                    }
                  ]
                },
                "3": {
                  "value": [
                    {
                      "type": 0,
                      "value": "three"
                    }
                  ]
                },
                "4": {
                  "value": [
                    {
                      "type": 0,
                      "value": "four"
                    }
                  ]
                },
                "5": {
                  "value": [
                    {
                      "type": 0,
                      "value": "five"
                    }
                  ]
                },
                "6": {
                  "value": [
                    {
                      "type": 0,
                      "value": "six"
                    }
                  ]
                },
                "7": {
                  "value": [
                    {
                      "type": 0,
                      "value": "seven"
                    }
                  ]
                },
                "8": {
                  "value": [
                    {
                      "type": 0,
                      "value": "eight"
                    }
                  ]
                },
                "9": {
                  "value": [
                    {
                      "type": 0,
                      "value": "nine"
                    }
                  ]
                },
                "other": {
                  "value": [
                    {
                      "type": 1,
                      "value": "numberOfProjects"
                    }
                  ]
                }
              },
              "type": 5,
              "value": "numberOfProjects"
            },
            {
              "type": 0,
              "value": " projects"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "numberOfProjects"
    },
    {
      "type": 0,
      "value": "* assigned to you with new work items you haven't checked out yet."
    }
  ],
  "post-office.growth.jira-assigned-nudge-digest.hello-message-for-one-project-work-items": [
    {
      "type": 0,
      "value": ":wave: Just a heads up — you were assigned "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "a work item in *<"
            },
            {
              "type": 1,
              "value": "projectUrl"
            },
            {
              "type": 0,
              "value": "|"
            },
            {
              "type": 1,
              "value": "projectName"
            },
            {
              "type": 0,
              "value": ">*"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "some work items in *<"
            },
            {
              "type": 1,
              "value": "projectUrl"
            },
            {
              "type": 0,
              "value": "|"
            },
            {
              "type": 1,
              "value": "projectName"
            },
            {
              "type": 0,
              "value": ">*"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "numberOfWorkItems"
    },
    {
      "type": 0,
      "value": " over three days ago."
    }
  ],
  "post-office.growth.jira-assigned-nudge-digest.max-top-work-items-message": [
    {
      "type": 0,
      "value": "You've got *"
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "one item"
            }
          ]
        },
        "other": {
          "value": [
            {
              "options": {
                "2": {
                  "value": [
                    {
                      "type": 0,
                      "value": "two"
                    }
                  ]
                },
                "3": {
                  "value": [
                    {
                      "type": 0,
                      "value": "three"
                    }
                  ]
                },
                "4": {
                  "value": [
                    {
                      "type": 0,
                      "value": "four"
                    }
                  ]
                },
                "5": {
                  "value": [
                    {
                      "type": 0,
                      "value": "five"
                    }
                  ]
                },
                "6": {
                  "value": [
                    {
                      "type": 0,
                      "value": "six"
                    }
                  ]
                },
                "7": {
                  "value": [
                    {
                      "type": 0,
                      "value": "seven"
                    }
                  ]
                },
                "8": {
                  "value": [
                    {
                      "type": 0,
                      "value": "eight"
                    }
                  ]
                },
                "9": {
                  "value": [
                    {
                      "type": 0,
                      "value": "nine"
                    }
                  ]
                },
                "other": {
                  "value": [
                    {
                      "type": 1,
                      "value": "numberOfWorkItems"
                    }
                  ]
                }
              },
              "type": 5,
              "value": "numberOfWorkItems"
            },
            {
              "type": 0,
              "value": " items"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "numberOfWorkItems"
    },
    {
      "type": 0,
      "value": "* to check on — here are three:"
    }
  ],
  "post-office.growth.jira-assigned-nudge-digest.plural-cta-message": [
    {
      "type": 0,
      "value": "See inactive "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "item"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "items"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "numberOfWorkItems"
    }
  ],
  "post-office.growth.jira-assigned-nudge-digest.top-projects-message": [
    {
      "type": 0,
      "value": "Here are three to get you started:"
    }
  ],
  "post-office.growth.recommendation-jpd.confluence-home-banner.description": [
    {
      "type": 0,
      "value": "Make sure your team is building the right things with Jira Product Discovery."
    }
  ],
  "post-office.growth.recommendation-jpd.confluence-home-banner.header": [
    {
      "type": 0,
      "value": "Capture your ideas and customer feedback all in one place"
    }
  ],
  "post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text": [
    {
      "type": 0,
      "value": "Jira Product Discovery Product Logo"
    }
  ],
  "post-office.growth.recommendation-jsm.confluence-home-banner.description": [
    {
      "type": 0,
      "value": "Automatically turn Slack, Teams, and email requests into tickets."
    }
  ],
  "post-office.growth.recommendation-jsm.confluence-home-banner.header": [
    {
      "type": 0,
      "value": "See the whole picture, from request to resolution"
    }
  ],
  "post-office.growth.recommendation-jsm.confluence-home-banner.logo-alt-text": [
    {
      "type": 0,
      "value": "Jira Service Management Product Logo"
    }
  ],
  "post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.description": [
    {
      "type": 0,
      "value": "See analytics and insights about what your team is working on at any moment"
    }
  ],
  "post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.header": [
    {
      "type": 0,
      "value": "Sync real-time data from Jira to any document in Confluence"
    }
  ],
  "post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.logo-alt-text": [
    {
      "type": 0,
      "value": "Jira Product Logo"
    }
  ],
  "post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.description": [
    {
      "type": 0,
      "value": "76% customers shipped projects faster after adding Confluence and Jira."
    }
  ],
  "post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.header": [
    {
      "type": 0,
      "value": "Build world-class products, fast"
    }
  ],
  "post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.logo-alt-text": [
    {
      "type": 0,
      "value": "Jira Product Logo"
    }
  ],
  "post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.description": [
    {
      "type": 0,
      "value": "Jira lets you view your project and tasks in a way that works for you and your team."
    }
  ],
  "post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.header": [
    {
      "type": 0,
      "value": "Visualize any project in a list, board, backlog, and more"
    }
  ],
  "post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.logo-alt-text": [
    {
      "type": 0,
      "value": "Jira Product Logo"
    }
  ],
  "post-office.jira-side-nav-first-party-recommendation.try-product": [
    {
      "type": 0,
      "value": "Try Product"
    }
  ],
  "post-office.jira-your-work-first-party-recommendation.learn-more": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "post-office.jira-your-work-first-party-recommendation.learn-more.alt-text": [
    {
      "type": 0,
      "value": "Discover more about "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "post-office.jira-your-work-first-party-recommendation.try-it-now": [
    {
      "type": 0,
      "value": "Try it now"
    }
  ],
  "post-office.jira-your-work-first-party-recommendation.try-product": [
    {
      "type": 0,
      "value": "Try Product"
    }
  ],
  "post-office.nav-4-projects-recommendations.cta-button-lozenge-try": [
    {
      "type": 0,
      "value": "Try"
    }
  ],
  "post-office.nav-4-projects-recommendations.reasons-modal-bullet-one-spork": [
    {
      "type": 0,
      "value": "the tools you use (Jira)"
    }
  ],
  "post-office.nav-4-projects-recommendations.reasons-modal-bullet-two-appify": [
    {
      "type": 0,
      "value": "the way you use your existing tools and apps"
    }
  ],
  "post-office.nav-4-projects-recommendations.reasons-modal-explanation": [
    {
      "type": 0,
      "value": "We think "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " will improve your team's productivity. The recommendation is based on:"
    }
  ],
  "post-office.nav-4-projects-recommendations.section-heading": [
    {
      "type": 0,
      "value": "Recommended"
    }
  ],
  "post-office.nav-4-requested-item.cta-button-dimissal": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.nav-4-requested-item.cta-button-lozenge-pending": [
    {
      "type": 0,
      "value": "Pending"
    }
  ],
  "post-office.nav-4-requested-item.product-roadmap-icon-alt-text": [
    {
      "type": 0,
      "value": "Icon for product roadmap"
    }
  ],
  "post-office.nav-4-requested-item.work-requests-icon-alt-text": [
    {
      "type": 0,
      "value": "Icon for work requests"
    }
  ],
  "post-office.placement-v2-nav-4-section.requested-main-heading": [
    {
      "type": 0,
      "value": "Requested"
    }
  ],
  "post-office.test-placement.main-heading.no-translate": [
    {
      "type": 0,
      "value": "Welcome to Placements v2"
    }
  ],
  "post-office.test-placement.test-message.dismiss-button.no-translate": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.test-placement.test-message.learn-more-button.no-translate": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "recommendation-controls.existing-products": [
    {
      "type": 0,
      "value": "your existing Atlassian products"
    }
  ],
  "recommendation-controls.team-size": [
    {
      "type": 0,
      "value": "the size of your team"
    }
  ],
  "recommendations.ad-controls.dismiss-flag.not-interested.subtitle": [
    {
      "type": 0,
      "value": "You won’t see this here as often."
    }
  ],
  "recommendations.ad-controls.dismiss-flag.not-interested.title": [
    {
      "type": 0,
      "value": "Got it, thanks for letting us know"
    }
  ],
  "recommendations.ad-controls.reasons-modal.accept-button.label": [
    {
      "type": 0,
      "value": "Ok"
    }
  ],
  "recommendations.ad-controls.reasons-modal.accept-button.label-ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "recommendations.ad-controls.reasons-modal.body": [
    {
      "type": 0,
      "value": "We think that "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " will improve your team's productivity. The recommendation is based on:"
    }
  ],
  "recommendations.ad-controls.reasons-modal.privacy-policy-link.text": [
    {
      "type": 0,
      "value": "Learn more about your data privacy with Atlassian"
    }
  ],
  "recommendations.ad-controls.reasons-modal.title": [
    {
      "type": 0,
      "value": "Why am I seeing this?"
    }
  ],
  "rovo-3p-party-integration-admin-nudge.action.connect": [
    {
      "type": 0,
      "value": "Connect now"
    }
  ],
  "rovo-3p-party-integration-admin-nudge.action.learnMore": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "rovo-3p-party-integration-admin-nudge.description.high-percentage-and-less-than-three-apps": [
    {
      "type": 0,
      "value": "Over 90% of your team shares content on "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "type": 1,
      "value": "secondAppName"
    },
    {
      "type": 0,
      "value": ", and other apps. Connecting makes search and chat more useful for everyone."
    }
  ],
  "rovo-3p-party-integration-admin-nudge.description.high-percentage-and-less-than-two-apps": [
    {
      "type": 0,
      "value": "Over 90% of your team works with shared content. Connecting makes search and chat more useful for everyone."
    }
  ],
  "rovo-3p-party-integration-admin-nudge.description.low-percentage": [
    {
      "type": 0,
      "value": "Most of your team works with shared content. Connecting makes search and chat more useful for everyone."
    }
  ],
  "rovo-3p-party-integration-admin-nudge.description.more-than-two-apps": [
    {
      "type": 1,
      "value": "percUsersConnected"
    },
    {
      "type": 0,
      "value": "% of your team shares content on "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "type": 1,
      "value": "secondAppName"
    },
    {
      "type": 0,
      "value": ", and other apps. Connecting makes search and chat more useful for everyone."
    }
  ],
  "rovo-3p-party-integration-admin-nudge.description.one-app": [
    {
      "type": 1,
      "value": "percUsersConnected"
    },
    {
      "type": 0,
      "value": "% of your team works with shared content. Connecting makes search and chat more useful for everyone."
    }
  ],
  "rovo-3p-party-integration-admin-nudge.more-apps-label": [
    {
      "type": 0,
      "value": "More apps"
    }
  ],
  "rovo-3p-party-integration-admin-nudge.title.more-than-two-apps": [
    {
      "type": 0,
      "value": "Connect more apps"
    }
  ],
  "rovo-3p-party-integration-admin-nudge.title.one-app": [
    {
      "type": 0,
      "value": "Connect "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "rovo-3p-party-integration-admin-nudge.title.two-apps": [
    {
      "type": 0,
      "value": "Connect "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "secondAppName"
    }
  ],
  "switcher.ad-controls.dropdown-item.not-interested.label": [
    {
      "type": 0,
      "value": "Not interested"
    }
  ],
  "switcher.ad-controls.dropdown-item.why-am-i-seeing-this.label": [
    {
      "type": 0,
      "value": "Why am I seeing this?"
    }
  ],
  "test": [
    {
      "type": 0,
      "value": "default message"
    }
  ]
}